import React from 'react';

import logo from '../imgs/logo-noa.png';
import logo2x from '../imgs/logo-noa@2x.png';

export default function AppLayout({children}) {
  return <div className='App'>
    <img
      src={logo}
      srcSet={`${logo2x} 2x`}
      alt='Noa'
      className='App-logo'
    />
    <div className='App-Content'>
      {children}
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/lib/AppLayout.js